import {
    ROUTE_MAIN,
    ROUTE_READ_PART
} from "../../App";
import React from "react";
import { Image, Link } from "@chakra-ui/react";
import { useEvoContext } from "../../context/evo.context";

export const ReadIssueWithImageLink = (props: any) => {
    const {
        maxWidth,
        rounded,
        alt,
        objectFit,
        imageSrc,
        borderRadius,
        style,
        textDecoration,
        ...rest
    } = props;

    const image = (
        <Image
            maxWidth={maxWidth}
            rounded={rounded}
            alt={alt}
            objectFit={objectFit}
            src={imageSrc}
            borderRadius={borderRadius}
            style={style}
            _hover={{ transform: "scale(1.05)", transition: "0.3s" }}
        />
    );

    return <ReadIssueLink image={image} textDecoration={textDecoration} {...rest} />;
};

export const ReadIssueLink = (props: any) => {
    const { hasSubscriptionActive } = useEvoContext();

    const {
        privateIssue,
        issue_id,
        image,
        page,
        label,
        textDecoration
    } = props;

    let route = ROUTE_MAIN + ROUTE_READ_PART;

    let pageNumber = '';
    if(page !== undefined && page !== '') {
        pageNumber = '/' + page;
    }

    let publicPart = '';
    if (!privateIssue && !hasSubscriptionActive) {
        publicPart = '/verejne'
    }

    const href = `${route}${issue_id}${pageNumber}${publicPart}`;

    return (
        <>
            {issue_id && (
                <Link href={href} textDecoration={textDecoration}>
                    {image}{label}
                </Link>
            )}
        </>
    );
};

